import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import { Action } from '../../../../components';
import { SendIcon } from '../../../../components/icon/solid';
import { resendInviteUserPermissionsRequest } from '../../../../store/modules/user-permissions/actions';
import { UserPermissions } from '../../../../types/items';

type Props = {
  userPermissions: UserPermissions;
};

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  icon: {
    color: palette.icons.send,
    fontSize: '1rem',
  },
}));

const ResendInviteAction = ({ userPermissions }: Props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const clickHandler = useCallback(() => {
    dispatch(resendInviteUserPermissionsRequest(userPermissions));
  }, [userPermissions, dispatch]);

  if (!userPermissions.permissions.can_edit) {
    return null;
  }
  return (
    <Action
      icon={<SendIcon className={classes.icon} />}
      title="Resend Invitation"
      onClick={clickHandler}
    />
  );
};

export default ResendInviteAction;
